import { Component, OnInit } from '@angular/core';
import { QuibblService } from '../quibbl.service';

@Component({
  selector: 'app-today',
  templateUrl: './today.component.html',
  styleUrls: ['./today.component.scss']
})
export class TodayComponent implements OnInit {

  public quibbls;
  public quibblSubscription;

  constructor(private _qb: QuibblService) { }

  ngOnInit() {
    this.quibblSubscription =
      this._qb.getTodayQuibbls().subscribe(quibbls => {
        this.quibbls = [];
        for(let i=quibbls.length-1; i>=0; i--) {
          this.quibbls.push(quibbls[i]);
        }
      });
  }

  ngOnDestroy() {
    if(this.quibblSubscription) this.quibblSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/today/today.component.ts